<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 -960 960 960" :width="size + 'px'" fill="currentColor">
    <path d="M360-200v-80h264L160-744l56-56 464 464v-264h80v400H360Z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconArrowSoutheast",
  mixins: [ IconBase ],
  props: { ...IconBase.props }
}
</script>